const initialState = () => {
  return {
    variant: "",
    message: "",
    showAlert: false
  };
};
const alert = {
  namespaced: true,
  state: initialState(),
  getters: {
    variant: state => state.variant,
    message: state => state.message,
    showAlert: state => state.showAlert
  },
  mutations: {
    setVariant(state, type) {
      state.variant = type;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setShowAlert(state, value) {
      state.showAlert = value;
    },
    resetState(state) {
      Object.assign(state, initialState());
    }
  },
  actions: {
    showSuccessAlert({ commit }, message) {
      commit("setVariant", "success");
      commit("setMessage", message);
      commit("setShowAlert", true);
    },
    showFailureAlert({ commit }, message) {
      commit("setVariant", "danger");
      commit("setMessage", message);
      commit("setShowAlert", true);
    },
    showInfoAlert({ commit }, message) {
      commit("setVariant", "warning");
      commit("setMessage", message);
      commit("setShowAlert", true);
    },
    hideAlert({ commit }) {
      commit("setShowAlert", false);
    }
  }
};

export default alert;
